import { Checkbox, FormControlLabel } from "@mui/material";
import { useForm } from "../../../../hooks/useForm/useForm";
import { FormProps } from "../../../form-types";
import { Database } from "../../../../../../lib/supabase";
import { TitleAndNameGroup } from "../../../form-input-components/groups/title-and-name.group";
import { AddressGroupShadcn } from "../../../form-input-components/groups/address.group";
import {
	SupabaseTableEnum,
} from "../../../../../../lib/supabase/supabaseTypes";
import React from "react";
import { CustomTextField } from "../../../form-input-components/custom-input-components/custom-text-field.component";
import { showNotification } from "@/dentlab/src/store/Central/selectors";
import { BankAccountSelect } from "../../bank-account/input-components/bank-account.select";
import { useCentralStore } from "@/dentlab/src/store/Central";
import { Button } from "@/dentlab/src/components/ui/button";

export const GuarantorForm: React.FC<
	FormProps & {
		guarantorId?: string;
	}
> = ({
	onSave = () => { },
	submitRef = null,
	guarantorId = undefined,
}) => {
		const supabaseTable = SupabaseTableEnum.GUARANTORS;

		const organizationId = useCentralStore((state) => state.organization?.id);
		const { getGuarantorLookup } = useCentralStore.getState();

		const isUpdate = guarantorId ? true : false;
		const useFormCustomFields = {
			organization_id: organizationId,
		};
		const useFormFetchData = isUpdate ? true : false;
		const useFormFetchId = isUpdate ? guarantorId : undefined;

		const {
			handleInputChange,
			handleCheckboxChange,
			handleCreate,
			formData,
			formErrors,
			handleValueChange,
			handleUpdate,
			resetFormData,
		} = useForm<Database["public"]["Tables"]["guarantors"]["Row"]>(
			useFormCustomFields,
			supabaseTable,
			useFormFetchData,
			useFormFetchId,
			"Garant"
		);

		const handleUpdateSubmit = async (
			event: React.FormEvent<HTMLFormElement>
		) => {
			return await handleUpdate(event, useFormFetchId);
		};

		const handleInsertSubmit = async (
			event: React.FormEvent<HTMLFormElement>
		) => {
			return await handleCreate(event);
		};

		const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
			const { success, data } = isUpdate
				? await handleUpdateSubmit(event)
				: await handleInsertSubmit(event);
			if (success && data) {
				await getGuarantorLookup();
				onSave(data[0]);
			} else {
				showNotification({
					message: "Es ist ein Fehler aufgetreten",
					type: "error",
				});
			}
		};

		return (
			<form onSubmit={onSubmit} className="flex flex-col gap-4 max-w-lg">

				<CustomTextField
					label="Garanten-Code"
					value={formData.code || ""}
					name="code"
					onChange={handleInputChange}
					required
				/>
				<FormControlLabel
					control={
						<Checkbox
							checked={formData.is_company ? true : false}
							onChange={handleCheckboxChange}
							name="is_company"
							color="primary"
						/>
					}
					label="Firmenadresse"
				/>
				{!formData.is_company && (
					<TitleAndNameGroup
						formData={formData}
						formErrors={formErrors}
						onChange={handleInputChange}
						onValueChange={(args) =>
							handleValueChange(args.name, args.value)
						}
						requiredFields={formData.is_company ? [] : ["title", "first_name", "last_name"]}
					/>
				)}
				{formData.is_company ? (
					<CustomTextField
						label="Firma / Organisation"
						name="company_name"
						value={formData.company_name || ""}
						onChange={handleInputChange}
						size="small"
						required
						validationError={formErrors?.company_name}
					/>
				) : (
					<CustomTextField
						label="Firma / Organisation (optional)"
						name="company_name"
						value={formData.company_name || ""}
						onChange={handleInputChange}
						size="small"
						validationError={formErrors?.company_name}
					/>
				)}
				<AddressGroupShadcn
					formData={formData}
					formErrors={formErrors}
					onChange={handleInputChange}
					onCheckboxChange={handleCheckboxChange}
					exclude={["phone_personal"]}
					onValueChange={(args) =>
						handleValueChange(args.name, args.value)
					}
					requiredFields={[
						"street",
						"city",
						"postal_code",
						"country",
					]}
				/>
				<FormControlLabel
					control={
						<Checkbox
							name="is_print_skonto"
							checked={formData.is_print_skonto ? true : false}
							onChange={handleCheckboxChange}
						/>
					}
					label={"Skonto statt Rabatt drucken"}
				/>
				<BankAccountSelect
					onChange={(value) =>
						handleValueChange("bank_account_id", value)
					}
					value={
						formData.bank_account_id
							? formData.bank_account_id.toString()
							: ""
					}
				/>

				<Button type="submit">Speichern</Button>
			</form>
		);
	};
